import BaseApi from './base.api'

class WebSiteApi extends BaseApi {
  availabilityTypesUrl = 'availability-types/'
  clipboardTypesUrl = 'clipboard-types/'
  citiesUrl = 'cities/'
  countriesUrl = 'countries/'
  currenciesUrl = 'currencies/'
  customerTypesUrl = 'customer-types/'
  elementLayoutsUrl = 'element-layouts/'
  permissionsUrl = 'permissions/'
  rolesUrl = 'roles/'
  identityDocumentAuthoritiesUrl = 'identity-authorities/'
  identityDocumentTypesUrl = 'identity-document-types/'
  mechanicsUrl = 'mechanics/'
  menuEntriesUrl = 'menu-entries/'
  notificationsUrl = 'notifications/'
  notificationsUnreadCountUrl = 'notifications/unread-count/'
  notificationsMarkAsReadUrl = 'notifications/mark-as-read/'
  notificationsSnoozeUrl = 'notifications/snooze/'
  notificationSettingsUrl = 'notifications/settings/'
  paymentTypesUrl = 'payment-types/'
  productTypesUrl = 'product-types/'
  settingsUrl = 'settings/'
  statesUrl = 'states/'
  supplierDivisionTypesUrl = 'supplier-division-types/'
  supplierTypesUrl = 'supplier-types/'
  unitsOfMeasureUrl = 'units-of-measure/'
  unitOfMeasureConversionsUrl = 'unit-of-measure-conversions/'
  urgencyTypesUrl = 'urgency-types/'
  usersUrl = 'users/'
  vatTypesUrl = 'vat-types/'

  constructor() {
    super('web-site/')
  }

  searchAsync = (q) => this.getAsync('search', { q })

  getDefaultElementLayoutAsync = (params) => this.getAsync(`${this.elementLayoutsUrl}default/`, params)
  upsertElementLayoutAsync = (data) => this.postAsync(`${this.elementLayoutsUrl}upsert-by-name/`, data)
  toggleElementLayoutSharedAsync = (id) => this.postAsync(`${this.elementLayoutsUrl}${id}/toggle-shared/`, {})
  setDefaultElementLayoutAsync = (id) => this.postAsync(`${this.elementLayoutsUrl}${id}/set-default/`, {})
  setDefaultBuiltinElementLayoutAsync = (data) => this.postAsync(`${this.elementLayoutsUrl}set-default-builtin/`, data)
  clearDefaultElementLayoutAsync = (data) => this.postAsync(`${this.elementLayoutsUrl}clear-default/`, data)

  activateUserAsync = (uid, token, password, isDryRun = false) => this.postAsync(`users/activate`, { uid, token, password, is_dry_run: isDryRun })

  getTokenAsync = (username, password) => this.postAsync('token', { username, password }, { credentials: 'include'})

  getRefreshTokenAsync = (config) => this.postAsync('token/refresh', {}, { credentials: 'include', _isRefreshCall: true, ...config })
  getUserDetailsAsync = (userId) => this.getAsync(`users/${userId}/details`)

  getAvailabilityTypesAsync = (params) => this.getAsync(this.availabilityTypesUrl, params)
  getCitiesAsync = (params) => this.getAsync(this.citiesUrl, params)
  getClipboardTypesAsync = (params) => this.getAsync(this.clipboardTypesUrl, params)
  getCountriesAsync = (params) => this.getAsync(this.countriesUrl, params)
  getCurrenciesAsync = (params) => this.getAsync(this.currenciesUrl, params)
  getCustomerTypesAsync = (params) => this.getAsync(this.customerTypesUrl, params)
  getIdentityDocumentAuthoritiesAsync = (params) => this.getAsync(this.identityDocumentAuthoritiesUrl, params)
  getIdentityDocumentTypesAsync = (params) => this.getAsync(this.identityDocumentTypesUrl, params)
  getLastUpdateAsync = () => this.getAsync('last-update')
  getMechanicsAsync = (params) => this.getAsync(this.mechanicsUrl, params)
  getMenuEntries = () => this.getAsync(this.menuEntriesUrl)
  getNotificationsUnreadCountAsync = (params) => this.getAsync(this.notificationsUnreadCountUrl, params)
  getPaymentTypesAsync = (params) => this.getAsync(this.paymentTypesUrl, params)
  getProductTypesAsync = (params) => this.getAsync(this.productTypesUrl, params)
  getSettingsAsync = (params) => this.getAsync(this.settingsUrl, params)
  getStatesAsync = (params) => this.getAsync(this.statesUrl, params)
  getSupplierDivisionTypesAsync = (params) => this.getAsync(this.supplierDivisionTypesUrl, params)
  getSupplierTypesAsync = (params) => this.getAsync(this.supplierTypesUrl, params)
  getUnitsOfMeasureAsync = (params) => this.getAsync(this.unitsOfMeasureUrl, params)
  getUrgencyTypesAsync = (params) => this.getAsync(this.urgencyTypesUrl, params)
  getUsersAsync = (params) => this.getAsync(this.usersUrl, params)
  getVatTypesAsync = (params) => this.getAsync(this.vatTypesUrl, params)

  logoutAsync = () => this.postAsync('logout', {}, { credentials: 'include' })

  updateUserDetailsAsync = (userId, data) => this.putAsync(`users/${userId}/details/`, data)
  saveDashboardLayoutAsync = (userId, layout) => this.putAsync(`users/${userId}/details/`, { dashboard_layout: layout })
}

export const webSiteApi = new WebSiteApi('web-site')
